
import React from 'react';
import { Separator } from '@/components/ui/separator';
import SubmitSection from '../../SubmitSection';
import { BusinessDetails } from '../../types';

interface FormContentFooterProps {
  businessDetails: BusinessDetails;
  handleSubmit: () => void;
  allStepsCompleted: boolean;
}

const FormContentFooter: React.FC<FormContentFooterProps> = ({
  businessDetails,
  handleSubmit,
  allStepsCompleted
}) => {
  return (
    <div className="mt-8">
      {allStepsCompleted && (
        <>
          <Separator className="mb-0" />
          <SubmitSection 
            businessDetails={businessDetails}
            handleSubmit={handleSubmit}
          />
        </>
      )}
    </div>
  );
};

export default FormContentFooter;
